import update from 'immutability-helper';
import { UserFeedbackCategory } from 'src/components/UserFeedbackModal/types';
import { storage } from 'src/utilities/Storage';
import { dayJs } from 'src/utilities/day';
import { ActionType, defaultAction } from '../types';
import { USER_FEEDBACK_ACTION_TYPES } from '../types/userFeedbackTypes';

type UserFeedbackState = {
  feature: string | null;
  categories: UserFeedbackCategory[];
  redirectPath: string | null;
};

const initialState: UserFeedbackState = {
  feature: null,
  categories: [],
  redirectPath: null,
};

export default function userFeedbackReducer(
  state = initialState,
  action: ActionType = defaultAction,
): UserFeedbackState {
  switch (action.type) {
    case USER_FEEDBACK_ACTION_TYPES.SHOW_USER_FEEDBACK_MODAL:
      const isKyb = action.payload.feature.startsWith('kyb');
      const storageKey = `userFeedback_lastShow:${action.payload.feature}`;
      const lastShow = storage.get(storageKey, null);
      const now = dayJs();
      const isExceed90Days =
        typeof lastShow === 'string' && now.diff(lastShow, 'days') >= 90;
      if (action.payload.feature !== 'general') {
        // all features except kyb will be shown once every 90 days
        if (!lastShow || (isExceed90Days && !isKyb)) {
          storage.set(storageKey, now.format('YYYY-MM-DD'));
        } else if (action.payload.redirectPath)
          return { ...state, redirectPath: action.payload.redirectPath };
        else return state;
      }
      return update(state, {
        $set: {
          categories: action.payload.categories ?? [],
          feature: action.payload.feature,
          redirectPath: action.payload.redirectPath,
        },
      });
    case USER_FEEDBACK_ACTION_TYPES.CLOSE_USER_FEEDBACK_MODAL:
      return update(state, {
        $set: {
          categories: [],
          feature: null,
          redirectPath: null,
        },
      });
    default:
      return state;
  }
}
